export const getAuthConfigById = async ($fire: any, id: string) => {
  return await $fire.firestore.collection('authConfig').doc(id).get()
}

export const getAuthConfig = async ($fire: any) => {
  return await $fire.firestore.collection('authConfig').limit(1).get()
}
